import React, { useEffect } from "react";

import useLayoutStore from "stores/useLayoutStore";
import { ErrorChunk } from "containers/Error/ErrorChunk";
const ErrorChunkPage = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <ErrorChunk />
    </>
  );
};

export default ErrorChunkPage;
